import React from "react";
import { Route, Switch } from "react-router-dom";

import { checkAuthentication } from "./checkAuthentication";

import Community from "Community/Community";
import Home from "../components/Home/Home";
import PublicPortal from "../components/PublicPortal";
import Settings from "Settings/Settings";
import ManageLayout from "Settings/ManageLayout/index";
import ManageDrawers from "Settings/ManageDrawers/ManageDrawers";
import ManagePublicPortal from "Settings/ManagePublicPortal";

export const urls = {
  index: "/",
  settings: "/settings",
  manageLayout: "/manage-layout",
  managePublicPortal: "/manage-public-portal",
  manageDrawers: "/manage-drawers",
  publicPortal: "/public/:communityName/:communityId",
  community: "/community/:communityName/:communityId",
  notFound: "*"
};

export const getRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      {/*}<Route exact path="/select-organization" component={Public} />*/}
      <Route path={urls.publicPortal} component={PublicPortal} />
      <Route
        path={urls.community}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(Community)}
      />
      <Route
        path={urls.settings}
        onUpdate={v => {
          window.scrollTo(0, 0);
        }}
        component={checkAuthentication(Settings)}
      />
      <Route
        path={urls.manageLayout}
        onUpdate={v => {
          window.scrollTo(0, 0);
        }}
        component={ManageLayout}
      />
      <Route
        path={urls.managePublicPortal}
        onUpdate={v => {
          window.scrollTo(0, 0);
        }}
        component={ManagePublicPortal}
      />
      <Route
        path={urls.manageDrawers}
        onUpdate={v => {
          window.scrollTo(0, 0);
        }}
        component={checkAuthentication(ManageDrawers)}
      />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./src/router/getRoutes.js